/** Carriers sahifalari lug'ati (en: manba). */
export default {
  title: "Carriers",
  subtitle_one: "{{count}} carrier · stats for {{scope}}",
  subtitle_other: "{{count}} carriers · stats for {{scope}}",
  newCarrier: "+ New carrier",
  filters: {
    status: "Status",
    statusAll: "Status: all",
    hiringState: "Hiring state",
    hiringAny: "Hiring state: any",
    trucks: "Trucks",
    trucksAll: "Any trucks",
    trucksAvailable: "Has free trucks",
    trucksExpiring: "Truck papers due",
    trucksAny: "Has trucks",
    openOnly: "Open jobs only",
    searchPlaceholder: "Search name, MC, contact",
    searchAria: "Search carriers",
  },
  empty: {
    filtered: "No carriers match these filters",
    none: "No carriers yet",
    manager: "Add the trucking companies you place drivers with.",
    viewer: "Your manager adds carriers.",
  },
  columns: {
    name: "Name",
    mcDot: "MC / DOT",
    status: "Status",
    mainContact: "Main contact",
    hiringStates: "Hiring states",
    openJobs: "Open jobs",
    freeTrucks: "Free trucks",
    submitted: "Submitted",
    hired: "Hired",
    rejection: "Rejection",
    driver: "Driver",
    recruiter: "Recruiter",
    job: "Job",
    date: "Date",
    states: "States",
    experience: "Experience",
    pay: "Pay",
    homeTime: "Home time",
    equipment: "Equipment",
    candidates: "Candidates",
    carrierReply: "Carrier reply",
    decided: "Decided",
  },
  pagination: { carriers: "carriers", candidates: "candidates" },
  scope: { allBranches: "all branches", yourBranch: "your branch", myDrivers: "my drivers" },
  states48: "48 states",
  withdrawn: "Withdrawn",
  rejectedWith: "Rejected · {{reason}}",
  reply: {
    noReply_one: "no reply · {{count}} day",
    noReply_other: "no reply · {{count}} days",
    waiting_one: "waiting · {{count}} day",
    waiting_other: "waiting · {{count}} days",
    started: "started {{date}}",
  },
  profile: {
    notFound: "Carrier not found.",
    statusToast: { active: "Carrier resumed", paused: "Carrier paused", stopped: "Carrier stopped" },
    updateFailed: "Could not update the carrier",
    hiringIn: "Hiring in: {{states}}",
    mainContact: "Main contact:",
    pause: "Pause",
    resume: "Resume",
    newJob: "+ New job",
    resumeFirst: "Resume the carrier first",
    tabs: { overview: "Overview", jobs: "Jobs ({{count}})", candidates: "Candidates ({{count}})", trucks: "Trucks ({{count}})", trucksFree: "Trucks ({{count}} · {{free}} free)", notes: "Notes" },
    kpi: {
      submitted: "Submitted",
      hired: "Hired",
      rejectionRate: "Rejection rate",
      openJobs: "Open jobs",
      allTime: "all time · {{scope}}",
      ofSubmitted: "{{pct}}% of submitted",
      noSubmissions: "no submissions yet",
      rejectedOf: "{{rejected}} of {{submitted}} submitted",
      carrierStatus: "carrier {{status}}",
      jobsTotal_one: "{{count}} job total",
      jobsTotal_other: "{{count}} jobs total",
    },
    openJobs: "Open jobs ({{count}})",
    allJobs: "All jobs →",
    noOpenJobs: "No open jobs.",
    topReasons: "Top rejection reasons",
    inScope: "in {{scope}}",
    noRejections: "No rejections yet.",
    recentCandidates: "Recent candidates",
    allCandidates: "All candidates →",
    noCandidatesForCarrier: "No candidates submitted to this carrier yet.",
    noJobs: "No jobs for this carrier",
    candidatesCount_one: "{{count}} candidate",
    candidatesCount_other: "{{count}} candidates",
    hiredOf: "{{hired}} of {{openings}} hired",
    noCandidatesYet: "No candidates yet",
    noCandidatesHint: "Drivers submitted to this carrier's jobs will appear here.",
    notesTitle: "Notes & submission",
    submissionMethod: "Submission method",
    replyTime: "Reply time",
    hiringStates: "Hiring states",
    added: "Added",
    notes: "Notes",
    noNotes: "No notes. Managers can add how this carrier likes to receive drivers.",
    resumeQ: "Resume {{name}}?",
    pauseQ: "Pause {{name}}?",
    resumeDesc: "Drivers can be submitted to this carrier again. Closed jobs stay closed until you reopen them.",
    pauseDesc: "Open jobs will be closed and drivers can no longer be submitted. Candidates in progress are not affected.",
    pauseCarrier: "Pause carrier",
    openJobsNow_one: "{{count}} open job right now.",
    openJobsNow_other: "{{count}} open jobs right now.",
  },
  form: {
    nameRequired: "Carrier name is required.",
    placementFee: "Payment per hired driver ($)",
    placementFeeHint: "Default for each new hire",
    mcRequired: "MC number is required.",
    saved: "Carrier saved",
    created: "Carrier created",
    saveFailed: "Could not save the carrier.",
    editTitle: "Edit carrier",
    newTitle: "New carrier",
    name: "Carrier name",
    mc: "MC #",
    dot: "DOT #",
    status: "Status",
    mainContact: "Main contact",
    phone: "Phone",
    email: "Email",
    city: "City",
    state: "State",
    replyTime: "Reply time",
    replyPlaceholder: "usually 3 business days",
    hiringStates: "Hiring states",
    all48: "All 48 states",
    pickStates: "Pick the states where this carrier hires",
    submissionMethod: "Submission method",
    submissionHint: "How drivers are sent: email packet, Tenstreet, carrier portal...",
    submissionPlaceholder: "email packet",
    notes: "Notes",
    notesPlaceholder: "Prefers drivers within 150 mi of Dallas",
  },
  trucks: {
    add: "Add truck",
    newTitle: "New truck",
    editTitle: "Truck {{unit}}",
    created: "Truck added",
    saved: "Truck saved",
    saveFailed: "Could not save the truck",
    statusSet: "Status: {{status}}",
    archiveTitle: "Archive truck {{unit}}?",
    archiveDesc: "It leaves the list and counts. History stays; it can be restored.",
    archived: "Truck archived",
    expired: "expired",
    noDriver: "No driver",
    freeCount_one: "{{count}} free truck",
    freeCount_other: "{{count}} free trucks",
    expiringCount_one: "{{count}} truck: papers due",
    expiringCount_other: "{{count}} trucks: papers due",
    empty: "No trucks yet",
    emptyFiltered: "No trucks with this status",
    emptyManager: "Add the carrier's trucks: a free truck means the carrier needs a driver.",
    emptyViewer: "A manager or the owner adds trucks.",
    chips: { all: "All" },
    cols: { truck: "Truck", trailer: "Trailer", status: "Status", driver: "Driver", location: "Location", plate: "Plate · VIN", insurance: "Insurance", inspection: "Inspection" },
    sections: { basic: "Truck", trailer: "Trailer", registration: "Registration and due dates", location: "Location and driver" },
    f: {
      unit: "Unit #", status: "Status", statusHint: "With a driver the truck is Assigned", year: "Year", make: "Make", model: "Model", cab: "Cab", transmission: "Transmission",
      trailerType: "Trailer type", trailerLength: "Length (ft)", plate: "Plate number", plateState: "Plate state", insurance: "Insurance expires",
      inspection: "Annual inspection due", inspectionHint: "DOT annual inspection", city: "City", state: "State", crew: "Solo / team",
      driver: "Driver", coDriver: "Second driver (team)", noDriver: "No driver", noHired: "No drivers hired at this carrier yet", notes: "Notes",
    },
    cab: { sleeper: "Sleeper", day_cab: "Day cab" },
    transmission: { automatic: "Automatic", manual: "Manual" },
    crew: { solo: "Solo", team: "Team" },
    trailer: { dry_van: "Dry van", reefer: "Reefer", flatbed: "Flatbed", step_deck: "Step deck", conestoga: "Conestoga", tanker: "Tanker", power_only: "Power only", box_truck: "Box truck", car_hauler: "Car hauler", other: "Other" },
  },
};
